import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectAllProducts,
  selectProductError,
  selectProductStatus,
} from '../redux/selectors/productSelector';
import { fetchProducts } from '../redux/slices/productSlice';

const useProducts = () => {
  const dispatch = useDispatch();
  const products = useSelector(selectAllProducts);
  const status = useSelector(selectProductStatus);
  const error = useSelector(selectProductError);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchProducts());
    }
  }, [dispatch, status]);

  return { products, status, error };
};

export default useProducts;
